module.exports = __webpack_public_path__ + "img/candidate-icon.d83c9857.png";